export const META_UPDATE = 'META_UPDATE';

export const updateMetaData = metaObj => ({
  type: META_UPDATE,
  payload: metaObj,
});



// WEBPACK FOOTER //
// ./src/actions/metaDataActions.js